import * as types from './constants';

// Get Codes Collections Scroll
export const getCodesCollectionsScrollRequest = data => (
  { type: types.GET_CODES_COLLECTIONS_SCROLL_REQUEST, payload: data }
);

export const getCodesCollectionsScrollDone = data => (
  { type: types.GET_CODES_COLLECTIONS_SCROLL_DONE, payload: data }
);

export const getCodesCollectionsScrollFailed = errors => (
  { type: types.GET_CODES_COLLECTIONS_SCROLL_FAILED, payload: errors }
);

export const getCodesCollectionsScrollReset = () => (
  { type: types.GET_CODES_COLLECTIONS_SCROLL_RESET }
);

// Optimistic operations
export const myCreatorsConnectedScrollOptimisticRemove = uuid => ({
  type: types.CODES_COLLECTIONS_SCROLL_OPTIMISTIC_REMOVE,
  payload: uuid
});

export const myCreatorsConnectedScrollOptimisticAdd = userRow => ({
  type: types.CODES_COLLECTIONS_SCROLL_OPTIMISTIC_ADD,
  payload: userRow
});

// Operations
export const toggleCodesCollectionsScroll = data => (
  { type: types.TOGGLE_CODES_COLLECTIONS_SCROLL, payload: data }
);

export const toggleAllCodesCollectionsScroll = data => (
  { type: types.TOGGLE_ALL_CODES_COLLECTIONS_SCROLL, payload: data }
);

export const setFilter = data => (
  { type: types.SET_CODES_COLLECTIONS_SCROLL_FILTER, payload: data }
);

export const setAllFilters = data => (
  { type: types.SET_CODES_COLLECTIONS_SCROLL_ALL_FILTERS, payload: data }
);

export const clearFilters = (filterToUpdate, mobile) => (
  { type: types.CLEAR_CODES_COLLECTIONS_SCROLL_FILTERS, payload: { filterToUpdate, mobile } }
);

// `url` is the `next` URL of the last loaded page; the request effect picks it up to load that page.
export const codesCollectionsScrollSetPageUrl = url => (
  { type: types.CODES_COLLECTIONS_SCROLL_SET_PAGE_URL, payload: url }
);